<script>

    import {createEventDispatcher, onMount} from "svelte";
    import images from "./images";
    import audio from "./audio";
    import isMobile from "../helpers/isMobile";

    const dispatch = createEventDispatcher();

    function loadImage(url) {
        return new Promise(resolve => {
            const image = new Image();
            image.addEventListener('load', () => {
                resolve(image);
            });
            image.src = url;
        });
    }

    function loadAudio(url) {
        return new Promise(resolve => {
            const audio = new Audio();
            audio.preload = 'auto';
            audio.addEventListener('canplaythrough', () => {
                resolve(audio);
            });
            audio.src = url;
        });
    }

    function dispatchLoadingStatus(percent) {
        dispatch('percentComplete', {
            percent
        });
    }

    function getLoadedPercent(images) {
        const total = Object.keys(images).length;
        const complete = Object.values(images).filter(Boolean).length;
        return complete / total * 100;
    }

    function loadAllFiles(images, audio) {
        const location = window.location.origin;
        const imagePath = location + '/images/';
        const audioPath = location + '/audio/';

        Object.keys(images).forEach((srcKey) => {
            loadImage(imagePath + srcKey)
                .then(img => {
                    images[srcKey] = img;
                    dispatchLoadingStatus(getLoadedPercent(images));
                })
                .catch(_ => {
                    console.warn('Failed to load ' + imagePath + srcKey);
                });
        });

        if (!isMobile()) {
            Object.keys(audio).forEach((srcKey) => {
                loadAudio(audioPath + srcKey)
                    .then(aud => {
                        audio[srcKey] = aud;
                    })
                    .catch(_ => {
                        console.warn('Failed to load ' + audioPath + srcKey);
                    });
            });
        }
    }

    onMount(() => {
       loadAllFiles(images, audio);
    });


</script>